import script from "./stdOnboardingFourthPage.vue?vue&type=script&setup=true&lang=js"
export * from "./stdOnboardingFourthPage.vue?vue&type=script&setup=true&lang=js"

import "./stdOnboardingFourthPage.vue?vue&type=style&index=0&id=dc0d62a0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dc0d62a0"]])

export default __exports__